import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { GoogleAnalytics } from './GoogleAnalytics';
import { GoogleTagManager } from './GoogleTagManager';
export const GoogleScripts = () => (_jsxs(_Fragment, { children: [_jsx(GoogleTagManager, {}), _jsx(GoogleAnalytics, {})] }));
